import { createAsyncThunk } from '@reduxjs/toolkit'
import { getOperationLogBatch, getOperationLogLegacyList, getOperationLogV2List } from '@/apis/aipass'
import type { OperationLogFiltersType, OperationLogLegacyFiltersType } from '@/models/operation-log'
import type { RootState } from '../store'

function httpStatusFromUnknown(error: unknown): number | undefined {
  if (typeof error !== 'object' || error === null) return undefined
  const res = (error as { response?: { status?: unknown } }).response
  if (typeof res !== 'object' || res === null) return undefined
  const s = (res as { status?: unknown }).status
  return typeof s === 'number' ? s : undefined
}

export const fetchOperationLogV2List = createAsyncThunk(
  'operationLog/fetchV2List',
  async (arg: { filters: OperationLogFiltersType; page: number; limit: number }, { rejectWithValue }) => {
    try {
      return await getOperationLogV2List({
        ...arg.filters,
        page: arg.page,
        limit: arg.limit,
      })
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const fetchOperationLogLegacyList = createAsyncThunk(
  'operationLog/fetchLegacyList',
  async (arg: { filters: OperationLogLegacyFiltersType; page: number; limit: number }, { rejectWithValue }) => {
    try {
      return await getOperationLogLegacyList({
        ...arg.filters,
        page: arg.page,
        limit: arg.limit,
      })
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const fetchOperationLogBatchDetail = createAsyncThunk(
  'operationLog/fetchBatchDetail',
  async ({ batchUuid }: { batchUuid: string }, { rejectWithValue }) => {
    try {
      const data = await getOperationLogBatch(batchUuid)
      return { batchUuid, data }
    } catch (error: unknown) {
      if (httpStatusFromUnknown(error) === 404) {
        return { batchUuid, data: null }
      }
      return rejectWithValue(error)
    }
  },
  {
    dispatchConditionRejection: true,
    condition: ({ batchUuid }, { getState }) => {
      const { operationLog } = getState() as RootState
      const cached = operationLog.detailsByBatchUuid[batchUuid]
      if (cached !== undefined) return false
      if (operationLog.detailInFlight[batchUuid]) return false
      return true
    },
  },
)
